import { FormGroup, AbstractControl, ValidatorFn, ValidationErrors } from "@angular/forms";

export function validateTermino() {

    return (form: FormGroup) => {

        const terms:number = parseInt(form.value.inputTermino);
        const edad:number = parseInt(form.value.inputEdad);

        if( (terms+edad) > 80 || terms < 10) {
           return form.controls['inputTermino'].setErrors({ termValid: true });
        }

        return  form.controls['inputTermino'].setErrors(null);
    }
}

export function validateAnyosPagos() {

    return (form: FormGroup) => {
        const terms:number = parseInt(form.value.inputTermino);
        const anyos:number = parseInt(form.value.inputNroAnosPago);

        if(!anyos) {
            return form.controls['inputNroAnosPago'].setErrors({ required: true });
        }
        else if( anyos > terms || anyos == 0) {
           return form.controls['inputNroAnosPago'].setErrors({ anyosValid: true });
        }

        return  form.controls['inputNroAnosPago'].setErrors(null);
    }
}

export function formatMoney(control) {

    return (form: FormGroup) => {
        const terms:number = parseInt(form.value.inputTermino);
        const anyos:number = parseInt(form.value.inputNroAnosPago);

        if(!anyos) {
            return form.controls['inputNroAnosPago'].setErrors({ required: true });
        }
        else if( anyos > terms || anyos == 0) {
           return form.controls['inputNroAnosPago'].setErrors({ anyosValid: true });
        }

        return  form.controls['inputNroAnosPago'].setErrors(null);
    }
}